import {
  Box,
  Button,
  Typography,
  Avatar,
  Paper,
  Grid,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useNavigate, useSearchParams } from "react-router-dom";
import { RouteUrls } from "../../Constants/RouteUrls";
import { Fragment, useState } from "react";
import { OtpMethodDataArr, PasswordMethodDataArr } from "./Data";
import { commonFormSwitch } from "../../Utils/SwitchCases";
import { HandleFormChange, ValidateFormData } from "../../Utils/Common";
import authApi from "Service/Auth.api";
import { useDispatch } from "react-redux";
import { setMyInfo } from "../../Redux/User/Action";
import { FormateMyInfoData } from "./Formatter";
import {
  setAlertData,
  startLoading,
  stopLoading,
} from "../../Redux/Screen/Action";
import ImgPath from "Constants/Imgs";
import { Home } from "@mui/icons-material";

const LoginPage = () => {
  const [formData, setFormData] = useState(PasswordMethodDataArr);
  const [loginMethod, setLoginMethod] = useState("password");
  const [otpSent, setOtpSent] = useState(false);

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [searchParams] = useSearchParams();

  const redirectAfterLogin = () => {
    const redirectParam = searchParams.get("redirect");
    let redirectUrl = `/${RouteUrls.dashboard}`; // default

    try {
      if (redirectParam) {
        const decodedRedirect = decodeURIComponent(redirectParam);

        const queryPart = decodedRedirect.split("?")[1];

        if (queryPart) {
          const params = new URLSearchParams(queryPart);
          const encodedOrder = params.get("data") || params.get("order"); // support both names

          if (encodedOrder) {
            // Decode and parse JSON data
            const decodedData = JSON.parse(decodeURIComponent(encodedOrder));

            // Store it in localStorage
            localStorage.setItem("selectedData", JSON.stringify(decodedData));

            if (decodedData.isSubscription === true && decodedData.redirectUrl) {
              window.location.href = decodedData.redirectUrl;
              return;
            }
          }
        }

        redirectUrl = decodedRedirect;
      }
    } catch (error) {
      console.error("Error handling redirect param:", error);
    }
    navigate(redirectUrl, { replace: true });
  };

  const handleLoginMethodChange = (method) => {
    setLoginMethod(method);
    setFormData(
      method === "otp"
        ? JSON.parse(JSON.stringify(OtpMethodDataArr))
        : JSON.parse(JSON.stringify(PasswordMethodDataArr))
    );
  };

  const handlePasswordToggle = (fieldId) => {
    setFormData((prev) =>
      prev.map((field) =>
        field.id === fieldId
          ? { ...field, showPassword: !field.showPassword }
          : field
      )
    );
  };

  const handleSendOTP = async () => {
    //API Call for sending OTP
    const res = await authApi.mobileSendOtp({
      mobileNumber: formData?.[0]?.value,
      requestType: "login",
    });
    if (res?.success) {
      setOtpSent(true);
      setFormData((prev) => {
        return prev.map((el) => {
          if (el.id === "otp") {
            el.readOnly = false; // Make OTP field editable after sending OTP
          }
          return el;
        });
      });
    }
  };
  const handleVerifyOtp = async () => {
    //API Call for Verifying OTP
    dispatch(startLoading({ loading: true, loadtext: "Verifying OTP..." }));
    const res = await authApi.verifyOtp({
      mobileNumber: formData?.[0]?.value,
      email: null,
      otp: formData?.[1]?.value,
    });
    if (res?.success) {
      dispatch(stopLoading());

      dispatch(
        setAlertData({
          alertMessage: "Otp Verified Successfully",
          alertVariant: "success",
          openAlert: true,
        })
      );
      localStorage.setItem("token", res?.data?.token);
       redirectAfterLogin();
    } else {
      dispatch(stopLoading());
    }
  };
  const handlepasswordVerifiction = async () => {
    const verification = ValidateFormData(formData);
    setFormData(verification.formData);
    if (!verification.errorCheck) {
      dispatch(startLoading({ loading: true, loadtext: "Signing In..." }));
      const res = await authApi.signIn({
        username: formData[0].value,
        password: formData[1].value,
      });
      if (res?.success) {
        dispatch(stopLoading());
        const myInfoData = FormateMyInfoData(res?.data);
        dispatch(setMyInfo(myInfoData));
        localStorage.setItem("token", res?.data?.token);
         redirectAfterLogin();
      } else {
        dispatch(stopLoading());
      }
    }
  };

  const handleSignIn = async () => {
    if (loginMethod === "otp") {
      if (!otpSent) {
        // 1st click — Send OTP
        handleSendOTP();
      } else {
        // 2nd click — Verify OTP
        handleVerifyOtp();
      }
    } else {
      // password login flow
      handlepasswordVerifiction();
    }
  };

  return (
    <Box sx={{ height: "100vh" }}>
      <Box>
        <Typography
          variant="h4"
          sx={{
            textAlign: "center",
            mt: 1,
            mb: 1,
            color: "primary.main",
          }}
        >
          <Box
            component="img"
            src={"https://nolegalpaisa.com/assets/images/nlp_logo.png"}
            alt="Logo"
            sx={{
              width: { xs: "150px", sm: "200px", md: "230px" },
              height: { xs: "60px", sm: "80px", md: "83px" },
              objectFit: "contain",
              cursor: "pointer",
              filter: "drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.3))",
              transition: "transform 0.2s ease-in-out",
              "&:hover": {
                transform: "scale(1.05)",
              },
            }}
            onClick={() => (window.location.href = "/home.html")}
          />
        </Typography>
      </Box>
      <Grid
        container
        component="main"
        sx={{ height: "80vh" }} // smaller height
        alignItems="center"
        justifyContent="center"
      >
        {!isSmallScreen && (
          <Grid
            item
            xs={false}
            sm={4}
            md={6}
            sx={{
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center",
              height: "100%",
            }}
          />
        )}

        <Grid
          item
          xs={12}
          sm={8}
          md={6}
          component={Paper}
          elevation={6}
          square
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
          }}
        >
          <Box
            sx={{
              mx: 4,
              width: "100%",
              maxWidth: 400,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              overflow: "hidden",
            }}
          >
            <Avatar sx={{ m: 1, bgcolor: "primary.main" }}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5" sx={{ mb: 2 }}>
              Sign in
            </Typography>

            <Box
              component="form"
              noValidate={false}
              sx={{ mt: 1, width: "100%" }}
            >
              {formData.map((el) => {
                return (
                  <Fragment key={el.id}>
                    {commonFormSwitch({
                      formObj: {
                        ...el,
                        onPasswordToggle: el.hasPasswordToggle
                          ? () => handlePasswordToggle(el.id)
                          : undefined,
                      },
                      onChange: (data) =>
                        setFormData(HandleFormChange(data, formData)),
                    })}
                  </Fragment>
                );
              })}
              {loginMethod === "otp" && (
                <Typography
                  sx={{ textDecoration: "underline", cursor: "pointer" }}
                  variant="body2"
                  onClick={() => handleLoginMethodChange("password")}
                >
                  {"Login Using Password"}
                </Typography>
              )}
              {loginMethod === "password" && (
                <Typography
                  sx={{ textDecoration: "underline" }}
                  variant="body2"
                  onClick={() => handleLoginMethodChange("otp")}
                >
                  {"Login Using OTP"}
                </Typography>
              )}
              <Button
                fullWidth
                sx={{ mt: 3, color: "#fff", backgroundColor: "primary.main" }}
                onClick={handleSignIn}
              >
                {loginMethod === "otp"
                  ? otpSent
                    ? "Verify OTP"
                    : "Send OTP"
                  : "Sign In"}
              </Button>

              <Typography
                sx={{
                  textAlign: "center",
                  textDecoration: "underline",
                  cursor: "pointer",
                  mt: 2,
                }}
                variant="body2"
                onClick={() => navigate(`/${RouteUrls.forgot}`)}
              >
                Forgot Password?
              </Typography>

              <Typography
                sx={{
                  textAlign: "center",
                  textDecoration: "underline",
                  cursor: "pointer",
                  mt: 2,
                }}
                variant="body2"
                onClick={() => navigate(`/${RouteUrls.register}`)}
              >
                {"Register as individual client"}
              </Typography>
              <Typography
                sx={{
                  textAlign: "center",
                  textDecoration: "underline",
                  cursor: "pointer",
                  mt: 2,
                }}
                variant="body2"
                onClick={() =>
                  navigate(`/${RouteUrls.register}/${RouteUrls.corporate}`)
                }
              >
                {"Register as Corporate Customer"}
              </Typography>
              <Typography
                sx={{
                  textAlign: "center",
                  textDecoration: "underline",
                  cursor: "pointer",
                  mt: 2,
                }}
                variant="body2"
                onClick={() =>
                  navigate(`/${RouteUrls.register}/${RouteUrls.professional}`)
                }
              >
                {"Are you a professional, Join us"}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
              <Button
                variant="outlined"
                startIcon={<Home />}
                sx={{ mt: 2 }}
                onClick={() => (window.location.href = "/home.html")}
              >
                Home
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default LoginPage;
